import { Liquid } from 'liquidjs';
import { moneyFiltersPlugin } from 'liquidjs-ov-money-filters';
import { timeagoFiltersPlugin } from 'liquidjs-ov-timeago-filters';

const engine = new Liquid();
engine.plugin(moneyFiltersPlugin);
engine.plugin(timeagoFiltersPlugin);

export function liquidRender(template, params, defaultValue) {
  try {
    return engine.parseAndRenderSync(template, params);
  } catch(error) {
    console.error(error);
  }

  if (defaultValue === undefined) return template;
  return defaultValue;
}
